// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__11cb6","header":"ReportDetails_header__Z38Yz","title":"ReportDetails_title__264iu","left":"ReportDetails_left__2eaUQ"};